import React from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvFeedback, AvGroup} from 'availity-reactstrap-validation';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {ACTION_REASON, LICENSE_STATUS, PURCHASE_ORDER_STATUS, SERVICE_NAME} from "../../shared/utils/Constants";
import {Fieldset} from "primereact/fieldset";
import DateInput from "../../shared/component/form/DateInput";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import SupplierService from "../../shared/service/SupplierService";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import PurchaseOrderItemColumn from "../../shared/component/dataTable/columns/PurchaseOrderItemColumn.json";
import Dialog from "../../shared/component/dialog/Dialog";
import StockSave from "../stock/StockSave";
import PurchaseOrderItemSave from "./PurchaseOrderItemSave";

const defaultLicense = {
    id: null,
    bssId: null,
    supplierName: null,
    supplierId: null,
    invoiceNumber: null,
    supplierAccountCode: null,
    deliveryDate: null,
    invoiceDate: null,
    createDate: null,
    orderTotal:null,
    purchaseOrderStatus:'NEW_ORDER',
    itemList:[]

};
const defaultItem = {
    id: null,
    bssId:null,
    name:null,
    barcode:null,
    supplierCode: null,
    itemUnit:null,
    unitSize: null,
    boxSize:null,
    orderQuantity:null,
    deliveryQuantity:null,
    boxPrice:null,
    vatRate:null,
    expiryDate:null
}

export default class PurchaseOrderItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            license: Object.assign({}, defaultLicense),
            licenseTemp: Object.assign({}, defaultLicense),
            renderExtraDataDeleteButton: false,
            pageMode: null,
        }
        this.purchaseOrderService = new PurchaseOrderService();
        this.supplierService = new SupplierService();
    }


    renderLicenses() {
        return (
            <div>


                <Fieldset legend={"License"}>
                    <ModalConfirm header='Warning' ok='OK' onOkClick={this.delete}
                                  onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                  show={this.state.displayShowStatusConfirmDialog}
                                  message={this.state.noticeResponse}/>
                    <Row>
                    </Row>
                    <Row>

                    </Row>

                    <Row>

                        <Col md="6">
                            <AvGroup>
                                <Label for="actionReason">
                                    <Translate contentKey="merchantBranch.actionReason">Status</Translate>
                                </Label>
                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="purchaseOrderStatus"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.actionReason}
                                    onChange={this.__handleChange}>
                                    {PURCHASE_ORDER_STATUS.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </Col>

                        <Col md="6">
                            <AvGroup>
                                <Label for="remainingDaysText">
                                    <Translate contentKey="merchantBranch.remainingDaysText">Invoice Number
                                    </Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="invoiceNumber"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.invoiceNumber}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </Col>

                        <Col md="6">
                            <AvGroup>
                                <Label for="remainingDaysText">
                                    <Translate contentKey="merchantBranch.remainingDaysText">Supplier Account Code
                                    </Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="supplierAccountCode"
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.supplierAccountCode}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </Col>
                    </Row>


                    <Row>
                        <Col md="6">
                            <AvGroup>
                                <Label for="createDate">
                                    <Translate
                                        contentKey="merchantBranch.createDate">Delivery Date</Translate>
                                </Label>

                                <DateInput
                                    name="deliveryDate"
                                    onChange={this.__handleChange}
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.deliveryDate}/>

                            </AvGroup>

                        </Col>
                        <Col md="6">
                            <AvGroup>
                                <Label for="updateDate">
                                    <Translate
                                        contentKey="merchantBranch.updateDate">Create Date</Translate>
                                </Label>

                                <DateInput
                                    name="createDate"
                                    onChange={this.__handleChange}
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.createDate}/>

                            </AvGroup>

                        </Col>

                        <Col md="6">
                            <AvGroup>
                                <Label for="updateDate">
                                    <Translate
                                        contentKey="merchantBranch.updateDate">Invoice Date</Translate>
                                </Label>

                                <DateInput
                                    name="invoiceDate"
                                    format={"DD/MM/YYYY"}
                                    onChange={this.__handleChange}
                                    disabled={!this.state.licenseSaveButtonRender}
                                    value={this.state.license.invoiceDate}/>

                            </AvGroup>

                        </Col>
                    </Row>

                    <Fieldset legend={"Items"}>

                        <Dialog visible={this.state.displayDialog}
                                header={""}
                                onHide={() => this.setState({displayDialog: false})}
                                style={GeneralUtils.getDialogStyleForProduct()}>

                            <PurchaseOrderItemSave ref={(elem) => this.refModelSave = elem}
                                       refreshDataTable={this.refreshDataTable}
                                       closeDisplayDialog={this.closeDisplayDialog}/>
                        </Dialog>

                        <Button color="outline-primary" style={{marginBottom: '5px'}} onClick={() => {
                            this.setState({displayDialog: true});
                        }}>
                            <Translate contentKey="entity.action.add">Add Item</Translate>
                        </Button>

                        <DataTableWithButton data={this.state.license.itemList}
                                             ref={(elem) => this.refDataTable = elem}
                                             selectionMode='single'
                                             paginator={false}
                                             fields={PurchaseOrderItemColumn.fields}> </DataTableWithButton>


                    </Fieldset>



                    {!this.state.licenseSaveButtonRender &&
                        <Button color="outline-primary" style={{marginRight: '5px', height: '30px'}} onClick={() => {
                            this.setState({licenseSaveButtonRender: true});
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}
                    {this.state.licenseSaveButtonRender &&
                        <Button color="outline-primary" style={{marginRight: '5px', height: '30px'}} onClick={() => {
                                this.savePurchaseOrderItem();

                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>
                    }

                    {this.state.licenseSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.license.id) &&

                        <Button color="outline-danger" style={{marginRight: '5px'}} onClick={() => {
                            this.showChangeStatusConfirmDialog(true)
                        }}>
                            <Translate contentKey="entity.action.add">Delete</Translate>
                        </Button>}


                </Fieldset>

                <Button color="outline-primary" style={{marginRight: '5px', height: '30px'}} onClick={() => {
                    this.setState({
                        licenseSaveButtonRender: false
                    });
                    this.props.closeDisplayDialog();

                }}>
                    <Translate contentKey="entity.action.cancel">Close</Translate>
                </Button>
            </div>
        )
    };


    savePurchaseOrderItem(){
        let license = this.state.license;
        if(!GeneralUtils.isNullOrEmpty(this.state.license.deliveryDate)){
            const deliveryDate = new Date(this.state.license.deliveryDate);
            const isoString = deliveryDate.toISOString();
            license['deliveryDate'] = deliveryDate.toISOString();
        }

        if(!GeneralUtils.isNullOrEmpty(this.state.license.invoiceDate)){
            const invoiceDate = new Date(this.state.license.invoiceDate);
            const isoString = invoiceDate.toISOString();
            license['invoiceDate'] = invoiceDate.toISOString();
        }

        this.setState({
            license: license,
        });
        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            this.purchaseOrderService.update(this.state.license)
                .then((response) => {
                    this.props.refreshDataTable();

                });
        } else {
            this.purchaseOrderService.create(this.state.license)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.props.refreshDataTable();
                    }
                });
        }
    }
    render() {
        return (
            <div class="p-col-12">
                {this.renderLicenses()}
            </div>
        );
    }

    delete = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            this.props.deleteAppLicense(this.state.license.id);
        }

        return undefined;
    }

    setChecked = (name, value) => {
        let license = this.state.license;
        license[name] = value;
        this.setState({license: license});
    }

    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.refDataTable.refresh();
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }



    licenseSaveButtonRender = () => {
        this.setState({licenseSaveButtonRender: true});
    }

    setData = (data) => {
        this.setState({
            license: data,
            licenseTemp: Object.assign({}, data),
            licenseSaveButtonRender: false,
            renderExtraDataDeleteButton: false
        });
    }

    showChangeStatusConfirmDialog = (value) => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to delete?"
        });
    }

    clearData = () => {
        let obj = Object.assign({}, defaultLicense);
        this.setState({license: obj, renderExtraDataDeleteButton: false});
    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let license = this.state.license;
        license[e.target.name] = value;
        this.setState({license: license});
    }


    __handleChangeStatus = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let license = this.state.license;
        license[e.target.name] = value;
        this.setState({license: license});
    }
}

PurchaseOrderItem.propTypes =
    {
        license: PropTypes.object
    }
;
